// For each entry in the below object, takes the arrays of the two IDs specified, 
// and combines them into one array with the name specified
const FILTER_REMAPPINGS = {
  Gordon: {
    panelIds: ["enjOdZmU43u4bD4jWlog", "omSPZlQzgyUsRKuT9bZE"],
  },
};

export default FILTER_REMAPPINGS;
